// WP-7.5 (ST-D): "installable shell + cached dashboard/agenda reads" — when the browser goes
// offline, the service worker's own cache may still be serving the last-known dashboard/agenda
// reads (never a write, AR-3's own boundary), so the owner is told plainly rather than left to
// wonder whether what they're looking at is current.
import { WifiOff } from 'lucide-react';
import { useOnlineStatus } from '../lib/online';

export function OfflineBanner(): React.JSX.Element | null {
  const online = useOnlineStatus();
  if (online) return null;

  return (
    <div
      role="status"
      className="flex items-center gap-2 bg-warning/10 px-4 py-2 text-sm text-warning"
    >
      <WifiOff size={14} />
      <span>You&rsquo;re offline — showing cached data where available.</span>
    </div>
  );
}
